import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  cautionBox: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid',
    borderRadius: '4px',
    margin: '5px 0px 0px 0px',
    backgroundColor: '#F44336',
    borderColor: '#F44336',
  },
  cautionText: {
    padding: 5,
    fontWeight: 400,
    color: 'white',
  },
}));

export const signaturePreviewStyles = {
  signatureBox: {
    mt: 1,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    p: 2,
    cursor: 'pointer',
    minHeight: '200px',
    gap: '10px',
    position: 'relative',
  },
  signatureImage: {
    height: 'auto',
    maxHeight: '200px',
    maxWidth: '100%',
    cursor: 'pointer',
    objectFit: 'contain',
  },

  addBtn: {
    height: '60px',
    objectFit: 'contain',
  },
  container: {
    border: '1px dashed #ccc',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    maxWidth: '100%',
  },
  imgContainer: {
    flex: 1,
    padding: '10px',
    height: '100px',
    cursor: 'crosshair',
  },
  removeBtn: {
    color: '#FF9900',
    fontWeight: 'bold',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
  },
};

export const normalInstructionStyle = {
  textStyle: {
    fontSize: '14px',
    '& ul': {
      margin: '1em 0!important',
      paddingLeft: '40px!important',
      listStyle: 'disc',
    },
    '& p:nth-child(1)': { marginTop: 0 },
  },
};
